import React, { useState } from 'react'
import { Select, Button } from 'antd';


const { Option } = Select;
const typeList = ['Accessory 1', 'Accessory 2', 'Accessory 3', 'Accessory 4'];
const brandList = ['Mahindra', 'John Deer', 'Eicher', 'Sonalika', 'Escort'];


function AccessoriesSearch() {
    const [type, setType] = useState("")
    const [brand, setBrand] = useState("")

    const changeType = (type) => {
        setType(type)
        setBrand("")
    }

    const onSearch = () => {
        console.log("AccessoriesSearch", type, brand)
    }

    return (
        <div>
            <div className="mt-8">
                <div className="mt-5">
                    <Select
                        size="large"
                        showSearch
                        placeholder="Select Type"
                        style={{ width: '100%' }}
                        // defaultValue={`Select Type`}
                        // value={type}
                        // value={this.state.secondCity}
                        onChange={changeType}
                    >
                    {typeList.map(h => (
                        <Option key={h}>{h}</Option>
                    ))}
                    </Select>
                </div>

                <div className="mt-3">
                    <Select
                        size="large"
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="Select Brand"
                        // defaultValue={`Select Brand`}
                        // value={brand}
                        onChange={setBrand}
                        >
                    {brandList.map(b => (
                        <Option key={b}>{b}</Option>
                    ))}
                    </Select>
                </div>
            </div>
            
            <div className="mt-8">
                <div className="inline">
                    <Button 
                        type="primary" 
                        size="large"
                        className="w-full" 
                        onClick={onSearch}
                    >
                        Search
                    </Button>
                </div>
                <div className="pt-2 inline">
                    <Button type="link" className="w-full" size="large">Find all accessories</Button>
                </div>
            </div>

        </div>
    );
}

export default AccessoriesSearch;
